
/**
 * http://usejsdoc.org/
 */
import { EventEmitter } from 'events';

import JumperApi from '../services/jumper-api';

import SchedulerApi from '../services/schedulerapi';

import reportsStore from './report-store';

import swal from 'sweetalert';

class Jumpers extends EventEmitter {
	constructor() {
		super();
		this.prefix = 'Jumpers_STORE_';
		this.jumpers = [];
		this.pilotOptions = [];
		this.tandemInstructors = [];
		this.affInstructors = [];
		this.videographers = [];
		this.tandemStudents = [];
		this.affStudents = [];
		this.coaches = [];
		this.staff = [];
		this.dailyActivities = {};
		this.holdJumperId = undefined;
		this.jumpersLoaded = false;
		this.tandemStudentsLoaded = false;
		this.loadAllJumpers = this.loadAllJumpers.bind(this);
		this.loadTandemStudents = this.loadTandemStudents.bind(this);

		this.jumpersAreLoaded = this.jumpersAreLoaded.bind(this);
		this.getJumperOptions = this.getJumperOptions.bind(this);
		this.getTandemInstructorOptions = this.getTandemInstructorOptions.bind(this);
		this.getTandemStudentOptions = this.getTandemStudentOptions.bind(this);
		this.getAffInstructorOptions = this.getAffInstructorOptions.bind(this);
		this.getAffStudentOptions = this.getAffStudentOptions.bind(this);
		this.getVideographerOptions = this.getVideographerOptions.bind(this);
		this.fuse = undefined;
	}

	setListeners = (socket) => {
		socket.on("staffStatusUpdate", data => {
			//alert('walkin created');
			var jumperActivity = data

			this.dailyActivities[jumperActivity.jumperId] = jumperActivity;

			this.emitResults(jumperActivity, 'staffStatusUpdate');

		});
		socket.on('updateTandemStudents', data => {
			//console.log('tandemStudentOptions socket io');
			//console.log(data);
			//alert('update tandem students');
			this.tandemStudents = data;

			this.tandemStudentsLoaded = true;

			var tandemStudentOptions = this.tandemStudents.map(jumper => { return { "label": jumper.firstname + " " + jumper.lastname, "value": jumper } });

			this.emitResults(tandemStudentOptions, 'tandemStudentsLoaded');
		});

		socket.on('walkinTandemAdded', data => {
			//console.log('tandemStudentOptions socket io');
			//console.log(data);
			//alert('update tandem students');
			var indx = this.tandemStudents.findIndex(stud => stud._id === data.student._id);

			if (indx < 0) {
				this.tandemStudents.push(data.student);
			}
			else {
				this.tandemStudents[indx] = data.student;
			}

			this.tandemStudentsLoaded = true;

			var tandemStudentOptions = this.tandemStudents.map(jumper => { return { "label": jumper.firstname + " " + jumper.lastname, "value": jumper } });

			this.emitResults(tandemStudentOptions, 'tandemStudentsLoaded');
		});
		socket.on('loadJumpers', data => {
			//console.log('loading jumpers socket io');
			//alert('in socket io load jumper');
			//console.log(data);
			this.configureJumpers(data);
		});
		socket.on('jumperUpdated', data => {
			//alert('jumper updated');
			console.log("jumperUpdated data: ",data)
			var jumper = data;

			this.processJumper(jumper);
			//alert(JSON.stringify(r.data));
			//alert(JSON.stringify(this.jumpers.filter(jumper => jumper._id === r.data._id)[0]));
			var jumperOptions = this.jumpers.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });
			var staffOptions = this.staff.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });

			this.emitResults(jumperOptions, 'jumpersLoaded');
			this.emitResults(staffOptions, 'staffLoaded');
		});

		socket.on('jumperDeleted', data => {

			var jumper = data;

			console.log(data);

			this.jumpers = this.jumpers.filter(jp => jp._id.toString() !== jumper._id.toString());

			this.tandemInstructors = this.tandemInstructors.filter(jp => jp._id.toString() !== jumper._id.toString());

			this.videographers = this.videographers.filter(jp => jp._id.toString() !== jumper._id.toString());

			this.affInstructors = this.affInstructors.filter(jp => jp._id.toString() !== jumper._id.toString());

			this.coaches = this.coaches.filter(jp => jp._id.toString() !== jumper._id.toString());

			this.affStudents = this.affStudents.filter(jp => jp._id.toString() !== jumper._id.toString());

			this.pilots = this.pilots.filter(jp => jp._id.toString() !== jumper._id.toString());

			this.staff = this.staff.filter(jp => jp._id.toString() !== jumper._id.toString());

			var jumperOptions = this.jumpers.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });

			var staffOptions = this.staff.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });

			this.emitResults(jumperOptions, 'jumpersLoaded');

			this.emitResults(staffOptions, 'staffLoaded');
		});

		socket.on('newJumperAdded', data => {
			//console.log('loading jumpers socket io');
			//alert('in socket io load jumper');
			// console.log('jumper added socket event');

			// console.log(data);

			var jumper = data;

			this.processJumper(jumper);

			var jumperOptions = this.jumpers.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });

			var staffOptions = this.staff.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });

			this.emitResults(jumperOptions, 'jumpersLoaded');

			this.emitResults(staffOptions, 'staffLoaded');
		});
	}

	loadTandemStudents = () => {
		return new Promise((resolve, reject) => {

			//console.log('in loadTandemStudents');
			JumperApi.loadTodayTandemStudents().then((r) => {
				if (r.status == 200) {
					var Jumpers = r.data;

					var activeJumpersDisplay = [];

					this.tandemStudents = r.data;

					this.tandemStudentsLoaded = true;

					var tandemStudentOptions = this.tandemStudents.map(jumper => { return { "label": jumper.firstname + " " + jumper.lastname, "value": jumper } });
					//console.log('tandemStudentOptions');
					//console.log(this.tandemStudents);
					this.emitResults(tandemStudentOptions, 'tandemStudentsLoaded');
					return resolve(this.tandemStudentsLoaded);

				} else {
					this.emitError({ message: 'Load could not be created, please contact support.' });
				}
			})
				.catch(e => {
					//console.log(e);
					this.emitError({ message: 'Incomplete or Invalid data present' });
				});
		});
	}


	processJumper = (jumper) => {
		console.log('processJumper');
	

		var indx = this.jumpers.findIndex(val => val._id.toString() === jumper._id.toString());

		if (indx >= 0) {
			this.jumpers[indx] = jumper;
		}
		else {
			this.jumpers.push(jumper);
		}

		indx = this.staff.findIndex(val => val._id.toString() === jumper._id.toString());
		if (indx < 0) {
			this.staff.push(jumper);
		}

		var pushed = false;
		if (jumper.ratings.filter(rating => rating.rating === "TANDEM INSTRUCTOR").length > 0) {

			var indx = this.tandemInstructors.findIndex(val => val.uspaMemberNumber === jumper.uspaMemberNumber);

			if (indx >= 0) {
				this.tandemInstructors[indx] = jumper;
			}
			else {
				this.tandemInstructors.push(jumper);
			}
		}

		if (jumper.ratings.filter(rating => rating.rating === "VIDEOGRAPHER").length > 0) {

			var indx = this.videographers.findIndex(val => val.uspaMemberNumber === jumper.uspaMemberNumber);
			if (indx >= 0) {
				this.videographers[indx] = jumper;
			}
			else {
				this.videographers.push(jumper);
			}
		}

		if (jumper.ratings.filter(rating => rating.rating === "AFF INSTRUCTOR").length > 0) {

			var indx = this.affInstructors.findIndex(val => val.uspaMemberNumber === jumper.uspaMemberNumber);
			if (indx >= 0) {
				this.affInstructors[indx] = jumper;
			}
			else {
				this.affInstructors.push(jumper);
			}

		}

		if (jumper.ratings.filter(rating => rating.rating === "COACH").length > 0) {
			var indx = this.coaches.findIndex(val => val.uspaMemberNumber === jumper.uspaMemberNumber);
			if (indx >= 0) {
				this.coaches[indx] = jumper;
			}
			else {
				this.coaches.push(jumper);
			}
		}

		if (jumper.ratings.filter(rating => rating.rating === "PILOT").length > 0) {
			var indx = this.pilots.findIndex(val => val._id.toString() === jumper._id.toString());
			if (indx >= 0) {
				this.pilots[indx] = jumper;
			}
			else {
				this.pilots.push(jumper);
			}
		}

		if (jumper.ratings.filter(rating => rating.rating === "AFF STUDENT").length > 0) {
			////console.log('adding to aff student');

			var indx = this.affStudents.findIndex(val => val._id.toString() === jumper._id.toString());

			if (indx >= 0) {
				this.affStudents[indx] = jumper;
			}
			else {
				this.affStudents.push(jumper);
			}
		}

		if (jumper.ratings.filter(rating => rating.rating === "IAD STUDENT").length > 0) {
			////console.log('adding to iad student');

			var indx = this.iadStudents.findIndex(val => val.uspaMemberNumber === jumper.uspaMemberNumber);

			if (indx >= 0) {
				this.iadStudents[indx] = jumper;
			}
			else {
				this.iadStudents.push(jumper);
			}
		}

		/*
		var jumperOptions = this.jumpers.map(jumper => {
			var label = jumper.nickname;
			if (jumper.lastname) {
				label += " " + jumper.lastname;
			}
			if (jumper.manifestNumber) {
				label += " " + jumper.manifestNumber;
			}

			return { "label": label, "value": jumper }
		});

		//var staffOptions = this.staff.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });

		//var affStudentOptions = this.getAffStudentOptions();
		//var iadStudentOptions = this.getIadStudentOptions();
		*/
	}

	
	getCheckedInStatus = (jumperId) => {
		// console.log('in getDailyActivityFrontEnd');
		// console.log(jumperId);
		// console.log(this.dailyActivities);
		// console.log(this.dailyActivities[jumperId]);
		if (this.dailyActivities[jumperId] && this.dailyActivities[jumperId].isCheckedIn) {
			return true;
		}
		else {
			return false;
		}
	}

	getDailyActivity = (jumperId) => {
		return new Promise((resolve, reject) => {
			JumperApi.getDailyActivity(jumperId).then(r => {
				if (r.status == 200) {

					var jumperDailyActivity = r.data;
					// console.log('retrieved daily activity',jumperDailyActivity);
					//console.log(jumperDailyActivity);
					this.emitResults({ jumperId: jumperId, dailyActivity: jumperDailyActivity, isTandemStudent: false }, 'dailyActivity');
					resolve(jumperDailyActivity);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitResults({}, 'dailyActivity');
					this.emitError({ message: 'could not get daily activity' });
				}
			})
				.catch(e => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
				})
		});
	}

	getJumpWithSuggestions = (payload) => {
		return new Promise((resolve, reject) => {
			JumperApi.getJumpWithSuggestions(payload).then(r => {
				if (r.status == 200) {
					var jumpWithSuggestions = r.data.jumpWithSuggestions;

					//console.log(otherActivities);
					//console.log('retrieved daily activity');
					//console.log(jumperDailyActivity);
					resolve(jumpWithSuggestions);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitResults({}, 'dailyActivity');
					this.emitError({ message: 'could not get daily activity' });
				}
			})
				.catch(e => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
				})
		});
	}

	// loadAllJumpers = () => {
	// 	return new Promise((resolve, reject)=>{
	// 		JumperApi.loadAllJumpers().then((r)=>{
	// 			if(r.status==200){
	// 				var Jumpers = r.data;
	// 				var activeJumpersDisplay = [];
	// 				this.jumpers = r.data;
	// 				this.jumpersLoaded = true;
	// 				this.coaches = r.data.coaches;


	// 				var pilotOptions = this.jumpers.filter(jumper => {
	// 			           return jumper.ratings.filter(rating => rating.rating ==="PILOT").length > 0;
	// 			    }).map(pilot => {return {"label" : jumper.nickname + " " + " " + pilot.lastname + " " + pilot.manifestNumber, "value": pilot}});

	// 				this.tandemInstructors = this.jumpers.filter(jumper => {
	// 		              return jumper.ratings.filter(rating => rating.rating ==="TANDEM INSTRUCTOR").length > 0;
	// 		        });

	// 				var tandemInstructorOptions = this.tandemInstructors.map(jumper => {return {"label" : jumper.firstname + " " + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper}});

	// 				this.videographers = this.jumpers.filter(jumper => {
	// 		              return jumper.ratings.filter(rating => rating.rating ==="VIDEOGRAPHER").length > 0;
	// 		        });

	// 				var videographerOptions = this.videographers.map(jumper => {return {"label" : jumper.firstname + " " + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper}});

	// 				this.affInstructors = this.jumpers.filter(jumper => {
	// 	              return jumper.ratings.filter(rating => rating.rating ==="AFF INSTRUCTOR").length > 0;
	// 	          	});

	// 		        var affInstructorOptions = this.affInstructors.map(jumper => {return {"label" : jumper.firstname + " " + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper}});

	// 		        var jumperOptions = this.jumpers.map(jumper => {return {"label" : jumper.firstname + " " + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper}});
	// 		        jumperOptions = jumperOptions.filter(option => option.value.firstname!=="HOLD"||option.value.lastname!=="HOLD");

	// 		        this.affStudents = this.jumpers.filter(jumper => {
	// 		        	return jumper.ratings.filter(rating => rating.rating ==="AFF STUDENT").length >0;
	// 				});

	// 				var coachOptions = this.coaches.map(jumper => {return {"label": jumper.firstname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper}});


	// 		        var affStudentOptions = this.affStudents.map(jumper => {return {"label": jumper.firstname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper}});

	// 		        var option = tandemInstructorOptions.filter(option => option.value.firstname==="HOLD" && option.value.lastname==="HOLD")[0];
	// 		        option.label = "HOLD";

	// 		        var option = affInstructorOptions.filter(option => option.value.firstname==="HOLD" && option.value.lastname==="HOLD")[0];
	// 		        option.label = "HOLD";

	// 		        var option = videographerOptions.filter(option => option.value.firstname==="HOLD" && option.value.lastname==="HOLD")[0];
	// 		        option.label = "HOLD";

	// 		        this.emitResults(pilotOptions,'pilotsLoaded');
	// 				this.emitResults(tandemInstructorOptions, 'tandemInstructorsLoaded');
	// 				this.emitResults(videographerOptions, 'videographersLoaded');
	// 				this.emitResults(affInstructorOptions, 'affInstructorsLoaded');
	// 				this.emitResults(affStudentOptions, 'affStudentsLoaded');
	// 				this.emitResults(coachOptions, 'coachesLoaded');
	// 				this.emitResults(jumperOptions, 'jumpersLoaded');

	// 				//console.log('befor resolving in loadAllJumpers');
	// 				return resolve(this.JumpersLoaded);
	// 			}else{
	//               this.emitError({message:'Load could not be created, please contact support.'});
	//             }
	// 		}, (err) => reject(err))
	// 		.catch((err)=>{
	// 			//console.log(err);
	//     		this.emitError({message:'Incomplete or Invalid data present'});
	//     		reject(err);
	// 		});
	// 	});
	// }

	configureJumpers = (data) => {
		// console.log("data===",data)
		var Jumpers = data;
		var activeJumpersDisplay = [];
		this.jumpers = data.jumpers;
		this.tandemInstructors = data.tandemInstructors;
		this.videographers = data.videographers;
		this.affInstructors = data.affInstructors;
		this.coaches = data.coaches;
		this.affStudents = data.affStudents;
		this.pilots = data.pilots;
		this.staff = data.staff;
		this.jumpersLoaded = true;


		var pilotOptions = this.pilots.map(pilot => { return { "label": pilot.nickname + " " + pilot.lastname + " " + pilot.manifestNumber, "value": pilot } });

		var tandemInstructorOptions = this.tandemInstructors.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });

		var videographerOptions = this.videographers.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });

		var affInstructorOptions = this.affInstructors.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });

		var coachOptions = this.coaches.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });

		var staffOptions = this.staff.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });

		var jumperOptions = this.jumpers.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });

		jumperOptions = jumperOptions.filter(option => option.value.firstname !== "HOLD" || option.value.lastname !== "HOLD");

		var affStudentOptions = this.affStudents.map(jumper => { return { "label": jumper.firstname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });

		var option = tandemInstructorOptions.filter(option => option.value.firstname === "HOLD" && option.value.lastname === "")[0];
		option.label = "HOLD";

		var option = affInstructorOptions.filter(option => option.value.firstname === "HOLD" && option.value.lastname === "")[0];
		option.label = "HOLD";

		var option = videographerOptions.filter(option => option.value.firstname === "HOLD" && option.value.lastname === "")[0];
		option.label = "HOLD";

		//this.saveData('pilotOptions',pilotOptions);

		////console.log("pilotoption:" pilotOptions);

		this.emitResults(pilotOptions, 'pilotsLoaded');
		this.emitResults(tandemInstructorOptions, 'tandemInstructorsLoaded');
		this.emitResults(videographerOptions, 'videographersLoaded');
		this.emitResults(affInstructorOptions, 'affInstructorsLoaded');
		this.emitResults(affStudentOptions, 'affStudentsLoaded');
		this.emitResults(coachOptions, 'coachesLoaded');

		this.emitResults(jumperOptions, 'jumpersLoaded');
		this.emitResults(staffOptions, 'staffLoaded');

		return this.jumpersLoaded

	}

	loadAllDailyActivities = (jumperId) => {
		//console.log('in get AllDailyActivities');
		return new Promise((resolve, reject) => {
			JumperApi.getAllDailyActivity(jumperId).then(r => {
				if (r.status == 200) {

					var jumperAllDailyActivities = r.data.dailyActivities;
					var tandemDailyActivities = r.data.tandemDailyActivities;

					this.dailyActivities = jumperAllDailyActivities;
					this.tandemDailyActivities = tandemDailyActivities;

					//console.log(this.dailyActivities);
					this.emitResults({ dailyActivities: jumperAllDailyActivities, tandemDailyActivities: tandemDailyActivities }, 'AllDailyActivities');
					resolve(jumperAllDailyActivities);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitResults({}, 'AllDailyActivities');
					this.emitError({ message: 'could not get daily activity' });
				}
			})
				.catch(e => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
				})
		});
	}

	loadAllJumpers = () => {
		return new Promise((resolve, reject) => {
			JumperApi.initializeLocalJumpers().then((r) => {
				if (r.status == 200) {
					// console.log("DATAAAA: ",r);
					// console.log(this.configureJumpers(r.data),'this.configureJumpers(r.data)')
					return resolve(this.configureJumpers(r.data));
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else {
					this.emitError({ message: 'Load could not be created, please contact support.' });
				}
			}, (err) => reject(err))
				.catch((err) => {
					//console.log(err);
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}

	jumpersAreLoaded = () => {
		return this.jumpersLoaded;
	}

	getStaffOptions = () => {
		return this.staff.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });
	}

	getTeams = () => {
		return this.jumpers.filter(j => j.isTeam);
	}

	getTeamOptions = () => {
		let teamOptions = this.jumpers.filter(jmp => jmp.isTeam).map(ele => {
			let newObj = {}
			newObj.label = ele.teamname;
			newObj.value = ele;
			return newObj;
		})
		return teamOptions
	}
	
	getJumperOptions = () => {
		return this.jumpers.filter(j => j.isTeam !== true).map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper }});
	}

	getTandemInstructorOptions = () => {
		return this.tandemInstructors.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });
	}

	getTandemStudentOptions = () => {
		return this.tandemStudents.map(jumper => { return { "label": jumper.firstname + " " + jumper.lastname, "value": jumper } });
	}

	getAffInstructorOptions = () => {
		return this.affInstructors.map(jumper => { return { "label": jumper.nickname + " "  + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });
	}

	getCoachOptions = () => {
		return this.coaches.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });
	}

	getVideographerOptions = () => {
		return this.videographers.map(jumper => { return { "label": jumper.nickname + " "  + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });
	}

	getAffStudentOptions = () => {
		return this.affStudents.map(jumper => { return { "label": jumper.firstname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });
	}

	getPilotOptions = () => {
		return this.pilots.map(jumper => { return { "label": jumper.firstname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });
	}

	transferCredit = (payload) => {
		return new Promise((resolve, reject) => {
			JumperApi.TransferCredit(payload).then((r) => {
				if (r.status == 200) {
					//console.log('Success');
					//alert(JSON.stringify(r.data.to, null,2));
					//console.log(r.data.to);
					//console.log(r.data.from);
					this.emitResults(true, 'creditTransferEvent');
					this.emitResults({ toId: payload.toId, fromId: payload.fromId, toActivity: r.data.to, fromActivity: r.data.from }, 'transfer');
					reportsStore.setDropzoneTodayActivity(r.data.summary);

				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'Credit Could Not be transfer, please contact support.' });
					this.emitResults(true, 'creditTransferEvent');
				}
			})
				.catch((err) => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}

	submitPackJob = (payload) => {
		return new Promise((resolve, reject) => {
			JumperApi.submitPackJob(payload).then((r) => {
				if (r.status == 200) {
					var jumperDailyActivity = r.data.dailyActivity;
					var otherActivities = r.data.otherAccounts;
					this.dailyActivities[payload.packerId] = jumperDailyActivity;
					swal({
								title: "Success",
								text: jumperDailyActivity.name + " successfully checked in",
								icon: "success",
								dangerMode: false,
						})
					//console.log(otherActivities);
					//console.log('retrieved daily activity');
					//console.log(jumperDailyActivity);
					this.emitResults({ jumperId: payload.packerId, dailyActivity: jumperDailyActivity, otherActivities: otherActivities,isTandemStudent: false }, 'dailyActivity');
					resolve(jumperDailyActivity);
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'Jumper could not be created, please contact support.' });
				}
			})
				.catch((err) => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}

	removePackJob = (payload) => {
		return new Promise((resolve, reject) => {
			JumperApi.removePackJob(payload).then((r) => {
				if (r.status == 200) {
					var jumperDailyActivity = r.data.dailyActivity;
					var otherActivities = r.data.otherAccounts;
					this.dailyActivities[payload.packerId] = jumperDailyActivity;
					swal({
								title: "Success",
								text: jumperDailyActivity.name + " successfully checked in",
								icon: "success",
								dangerMode: false,
						})
					//console.log(otherActivities);
					//console.log('retrieved daily activity');
					//console.log(jumperDailyActivity);
					this.emitResults({ jumperId: payload.packerId, dailyActivity: jumperDailyActivity, otherActivities: otherActivities,isTandemStudent: false }, 'dailyActivity');
					resolve(jumperDailyActivity);
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'Jumper could not be created, please contact support.' });
				}
			})
				.catch((err) => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}

	Checkin = (id, tiaspi, video) => {
		return new Promise((resolve, reject) => {
			JumperApi.checkin(id, tiaspi, video).then((r) => {
				if (r.status == 200) {
					var jumperDailyActivity = r.data.dailyActivity;
					var otherActivities = r.data.otherAccounts;
					this.dailyActivities[id] = jumperDailyActivity;
					swal({
						title: "Success",
						text: jumperDailyActivity.name + " successfully checked in",
						icon: "success",
						dangerMode: false,
					})
					//console.log(otherActivities);
					//console.log('retrieved daily activity');
					//console.log(jumperDailyActivity);
					this.emitResults({ jumperId: id, dailyActivity: jumperDailyActivity, otherActivities: otherActivities, isTandemStudent: false }, 'dailyActivity');
					resolve(jumperDailyActivity);
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'Jumper could not be created, please contact support.' });
				}
			})
				.catch((err) => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}

	Checkout = (id) => {
		return new Promise((resolve, reject) => {
			JumperApi.checkout(id).then((r) => {
				if (r.status == 200) {
					var jumperDailyActivity = r.data.dailyActivity;
					var otherActivities = r.data.otherAccounts;
					this.dailyActivities[id] = jumperDailyActivity;
					swal({
						title: "Success",
						text: jumperDailyActivity.name + " successfully checked out",
						icon: "success",
						dangerMode: false,
					})
					//console.log(otherActivities);
					//console.log('retrieved daily activity');
					//console.log(jumperDailyActivity);
					//this.emitResults({ jumperId: id, dailyActivity: jumperDailyActivity, otherActivities: otherActivities,isTandemStudent: false }, 'dailyActivity');
					resolve(jumperDailyActivity);
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'Jumper could not be created, please contact support.' });
				}
			})
				.catch((err) => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}
	getStudentLogs = (id) => {
		return new Promise((resolve, reject) => {
			JumperApi.getStudentLogs(id).then((r) => {
				if (r.status == 200) {
					//console.log('Success');
					//alert(JSON.stringify(r.data.to, null,2));
					//console.log(r.data.to);
					//console.log(r.data.from);
					this.emitResults(r.data, 'studentLogSubmitted');
					//this.emitResults({ toId: payload.toId, fromId: payload.fromId, toActivity: r.data.to, fromActivity: r.data.from }, 'transfer');
					//reportsStore.setDropzoneTodayActivity(r.data.summary);

				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'Credit Could Not be transfer, please contact support.' });
					this.emitResults(true, 'creditTransferEvent');
				}
			})
				.catch((err) => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}

	submitStudentLog = (id, payload) => {
		return new Promise((resolve, reject) => {
			JumperApi.submitStudentLog(id, payload).then((r) => {
				if (r.status == 200) {
					//console.log('Success');
					//alert(JSON.stringify(r.data.to, null,2));
					//console.log(r.data.to);
					//console.log(r.data.from);
					this.emitResults(r.data, 'studentLogSubmitted');
					//this.emitResults({ toId: payload.toId, fromId: payload.fromId, toActivity: r.data.to, fromActivity: r.data.from }, 'transfer');
					//reportsStore.setDropzoneTodayActivity(r.data.summary);

				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'Credit Could Not be transfer, please contact support.' });
					this.emitResults(true, 'creditTransferEvent');
				}
			})
				.catch((err) => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}

	mapFunJumpForRender = (funJump) => {
		var funJumpForRender = {};
		funJumpForRender.jumpId = funJump.jumpId;
		funJumpForRender.jumpType = funJump.jumpType;
		//console.log(this.jumpers);
		funJumpForRender.jumpers = funJump.jumperIds.map(jumperId => {
			//alert(jumperId);
			var jumper = this.jumpers.filter(jumper => jumper._id.toString() === jumperId)[0];
			//alert(jumper);
			if (jumper != undefined) {
				return {
					_id: jumper._id,
					firstname: jumper.firstname,
					lastname: jumper.lastname,
					memberId: jumper.manifestNumber,
					gearRental: funJump.gearRentals.indexOf(jumper._id) >= 0
				};
			}
			else {
				return {
					_id: 'None',
					firstname: 'Hold',
					lastname: '',
					memberId: '',
					gearRental: ''
				};
			}
		});


		if (funJump.gearRentals && funJump.gearRentals.length >= 0) {
			funJumpForRender.gearRentals = funJump.gearRentals;
		}
		return funJumpForRender;

	}
	mapCoachJumpForRender = (coachJump) => {
		//console.log('in mapCoachForRender');
		//console.log(coachJump);
		var coachJumpForRender = {};
		coachJumpForRender.jumpId = coachJump.jumpId;

		var coach = this.staff.filter((coach) => coach._id.toString() === coachJump.coachId)[0];
		//console.log(coach)
		coachJumpForRender.coach = {
			_id: coach._id,
			firstname: coach.firstname,
			lastname: coach.lastname,
			memberId: coach.manifestNumber
		};

		var jumper = this.jumpers.filter((jumper) => jumper._id.toString() === coachJump.jumperId)[0];

		//console.log(jumper)
		coachJumpForRender.jumper = {
			_id: jumper._id,
			firstname: jumper.firstname,
			lastname: jumper.lastname
		}

		return coachJumpForRender;
	}

	mapTandemForRender = (tandemJump) => {
		//console.log('in mapTandemForRender');
		//console.log(tandemJump);
		var tandemJumpForRender = {};
		tandemJumpForRender.jumpId = tandemJump.jumpId;

		var instructor = this.staff.filter((instructor) => instructor._id.toString() === tandemJump.instructorId)[0];
		//console.log(instructor)
		tandemJumpForRender.instructor = {
			_id: instructor._id,
			firstname: instructor.firstname,
			lastname: instructor.lastname,
			memberId: instructor.manifestNumber
		};

		var student = this.tandemStudents.filter((student) => student._id.toString() === tandemJump.studentId)[0];

		// //console.log(student)
		// tandemJumpForRender.student ={
		// 		_id : student._id,
		// 		firstname : student.firstname,
		// 		lastname : student.lastname
		// }

		//console.log(student)
		if (student) {
			tandemJumpForRender.student = {
				_id: student._id,
				firstname: student.firstname,
				lastname: student.lastname
			}
		}
		else {
			tandemJumpForRender.student = {
				_id: 'none',
				firstname: 'HOLD',
				lastname: ''
			}
		}

		if (tandemJump.videographerId) {
			var videographer = this.staff.filter((videographer) => videographer._id.toString() === tandemJump.videographerId)[0];
			tandemJumpForRender.videographer = {
				_id: videographer._id,
				firstname: videographer.firstname,
				lastname: videographer.lastname,
				memberId: videographer.manifestNumber
			}
		}
		return tandemJumpForRender;
	}

	mapAffForRender = (affJump) => {
		//console.log('in mapAffForRender');
		//console.log(affJump);
		//console.log(this.affInstructors);
		var affJumpForRender = {};

		affJumpForRender.jumpId = affJump.jumpId;
		affJumpForRender.level = affJump.level;

		var mainInstructor = this.staff.filter((instructor) => instructor._id.toString() === affJump.mainInstructorId)[0];

		//console.log(mainInstructor);

		// affJumpForRender.mainInstructor ={
		// 		_id : mainInstructor._id,
		// 		firstname : mainInstructor.firstname,
		// 		lastname : mainInstructor.lastname,
		// 		memberId : mainInstructor.manifestNumber
		// };

		if (mainInstructor !== undefined) {
			affJumpForRender.mainInstructor = {
				_id: mainInstructor._id,
				firstname: mainInstructor.firstname,
				lastname: mainInstructor.lastname,
				memberId: mainInstructor.manifestNumber
			}
		}
		else {
			affJumpForRender.mainInstructor = {
				_id: 'none',
				firstname: 'Hold',
				lastname: 'HOLD',
				memberId: ''
			}
		}

		//console.log(this.affStudents);
		var student = this.affStudents.filter((student) => student._id.toString() === affJump.studentId)[0];
		//console.log(student);


		// affJumpForRender.student = {
		// 		_id : student._id,
		// 		firstname : student.firstname,
		// 		lastname : student.lastname
		// }

		if (student !== undefined) {
			affJumpForRender.student = {
				_id: student._id,
				firstname: student.firstname,
				lastname: student.lastname
			}
		}
		else {
			affJumpForRender.student = {
				_id: 'None',
				firstname: 'HOLD',
				lastname: ''
			}
		}


		if (affJump.secondaryInstructorId) {
			var secondaryInstructor = this.staff.filter((instructor) => instructor._id.toString() === affJump.secondaryInstructorId)[0];

			affJumpForRender.secondaryInstructor = {
				_id: secondaryInstructor._id,
				firstname: secondaryInstructor.firstname,
				lastname: secondaryInstructor.lastname,
				memberId: secondaryInstructor.manifestNumber
			}
		}

		if (affJump.videographerId) {
			var videographer = this.staff.filter((videographer) => videographer._id.toString() === affJump.videographerId)[0];
			affJumpForRender.videographer = {
				_id: videographer._id,
				firstname: videographer.firstname,
				lastname: videographer.lastname,
				memberId: videographer.manifestNumber
			}
		}
		return affJumpForRender;
	}

	addMediaUrl = (jumperId, payload) => {
		return new Promise((resolve, reject) => {
			JumperApi.addMediaUrl(jumperId, payload).then((r) => {
				if (r.status == 200) {
					var load = r.data.load;
					// console.log(r.data)
					// jumpersStore.setAllDailyActivities(r.data.dailyActivities);
					// reportsStore.setDropzoneTodayActivity(r.data.summary);
					// var newActivity = "tandem Jump updated on load";
					// this.emitResults(newActivity, 'newActivity');
					// this.emitResults(r.data, 'completeLoadRight');
					// this.emitResults(true, 'loadPriceEvent');
					this.emitResults(r.data.load, 'updateCompletedLoads');
					// updateLoadHistory(load);
					resolve(true);
				}
				else if (r.status == 401) {
					//this.emitResults(true,'clearSession');
					//this.emitResults(false,	'loadPriceEvent');
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'completed Jump could not be Updated, please contact support.' });
				}
				this.emitResults(false, 'InitilizeLoader');
			})
				.catch(err => {
					this.emitResults(false, 'InitilizeLoader');
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}

	sendTandemMediaEmail = (payload) => {
		return new Promise((resolve, reject) => {
			JumperApi.sendTandemMediaEmail(payload).then((r) => {
				if (r.status == 200) {
					var load = r.data.load;
					// console.log(r.data)
					// jumpersStore.setAllDailyActivities(r.data.dailyActivities);
					// reportsStore.setDropzoneTodayActivity(r.data.summary);
					// var newActivity = "tandem Jump updated on load";
					// this.emitResults(newActivity, 'newActivity');
					// this.emitResults(r.data, 'completeLoadRight');
					// this.emitResults(true, 'loadPriceEvent');
					this.emitResults(r.data.load, 'updateCompletedLoads');
					// updateLoadHistory(load);
					resolve(true);
				}
				else if (r.status == 401) {
					//this.emitResults(true,'clearSession');
					//this.emitResults(false,	'loadPriceEvent');
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'completed Jump could not be Updated, please contact support.' });
				}
				this.emitResults(false, 'InitilizeLoader');
			})
				.catch(err => {
					this.emitResults(false, 'InitilizeLoader');
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err)
				});
		});
	}

	addCardOnFileUpdate = (id, payload) => {
		////alert('in create jumper jumper store');
		return new Promise((resolve, reject) => {
			var jumpers = this.jumpers.filter(jumper => jumper._id === id)[0];
			jumpers.cardsOnFile.push(payload);
			JumperApi.UpdateJumper(id, jumpers).then((r) => {
				if (r.status == 200) {
					console.log("UpdateAPIResponse: ", r);
					var jumper = r.data;


					if (jumper != null) {
						//alert('updating jumper list');
						var jumpersArr = this.jumpers;

						jumpersArr.filter(jumper => jumper._id === r.data._id)[0] = r.data;
						this.jumpers = jumpersArr;
					}

					//alert(JSON.stringify(r.data));
					//alert(JSON.stringify(this.jumpers.filter(jumper => jumper._id === r.data._id)[0]));
					var jumperOptions = this.jumpers.map(jumper => { return { "label": jumper.nickname + " " + jumper.lastname + " " + jumper.manifestNumber, "value": jumper } });

					this.emitResults(jumperOptions, 'jumpersLoaded');
					this.emitResults(r.data.cardsOnFile, 'cardAddEvent');
					//console.log('Success')
					resolve(true);
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {

					this.emitError({ message: 'Jumper could not be created, please contact support.' });
					resolve(false)
				}
			})
				.catch((err) => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}
	getJumpers = () => {
		//console.log('in getJumpers()');
		//console.log(this.jumpers);
		return this.jumpers;
	}

	emitError = (err) => {
		//console.log(err);
		this.emit('ERROR', err.message);
	}

	getEventPrefix = (func) => {
		return `${this.prefix}${func}`;
	}

	setAllDailyActivities = (dailyActivities, tandemDailyActivities) => {
		this.dailyActivities = dailyActivities;
		this.tandemDailyActivities = tandemDailyActivities;
	}

	emitResults = (r, func) => {
		//console.log('emitResults');
		if (!r) {
			//console.log(r);
			this.emitError({ message: 'No Jumpers found' });
		}
		this.setMaxListeners(1000);
		//console.log(r);
		this.emit(`${this.prefix}${func}`, r);
	}
	debug = (r) => {
		//console.log(r.data);
	}


	getAllJumpers = () => {
		return new Promise((resolve, reject) => {
			JumperApi.loadAllJumpersNew().then((r) => {
				// console.log("🚀 ~ file: jumpers-store.js ~ line 1132 ~ Jumpers ~ JumperApi.loadAllJumpersNew ~ r", r)
				if (r.status == 200) {
					return resolve(r.data);
				}
				else if (r.status == 401) {
					this.emitResults(true, 'clearSession');
				}
				else {
					this.emitError({ message: 'Load could not be created, please contact support.' });
				}
			}, (err) => reject(err))
				.catch((err) => {
					//console.log(err);
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}

	getJumperDetails = (payload) => {
		return new Promise((resolve, reject) => {
			JumperApi.getJumperDetails(payload).then(res => {
				// console.log(res," res.data res.data")
				resolve(res.data)
			}).catch(err => {
				reject(err)
			})
		})
	}
	getCardDetails = (id) => {
		return this.jumpers.filter(ele => ele._id === id);
	}
	removeCardOnFile = (jumperid, id) => {
		return new Promise((resolve, reject) => {
			JumperApi.RemoveCardOnFile(jumperid, id).then((r) => {
				if (r.status == 200) {
					var jumper = r.data;
					this.jumpers = this.jumpers.map(ele => {
						if (ele._id === jumper._id) {
							ele.cardsOnFile = jumper.cardsOnFile
						}
						return ele;
					})
					this.emitResults(jumper, 'deleteCardEvent');
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'card could not be removed, please contact support.' });
				}
			})
				.catch((err) => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}
	removeAccountOnFile = (jumperid, id) => {
		return new Promise((resolve, reject) => {
			JumperApi.RemoveAccountOnFile(jumperid, id).then((r) => {
				if (r.status == 200) {
					var jumper = r.data;
					this.emitResults(jumper, 'deleteAccountEvent');
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'card could not be removed, please contact support.' });
				}
			})
				.catch((err) => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					reject(err);
				});
		});
	}
	updateJumper = (id, JumperBody) => {
		return new Promise((resolve, reject) => {
			JumperApi.UpdateJumper(id, JumperBody).then((r) => {
				if (r.status == 200) {
					//handle in socket
					resolve(true);
					this.emitResults(JumperBody, 'jumperUpdated');
					//console.log(r.data);
				}
				else if (r.status === 500 || r.status === 404) {
					this.emitResults(true, 'warningEvent');
					resolve(false);
				}
				else {
					this.emitError({ message: 'Jumper could not be created, please contact support.' });
				}
			})
				.catch((err) => {
					this.emitError({ message: 'Incomplete or Invalid data present' });
					console.log('ERR: ', err);
					reject(err);
				});
		});
	}
}

const jumpersStore = new Jumpers();
window.jumpersStore = jumpersStore;
export default jumpersStore;
